import React, { useState } from "react";
import { Redirect, Link } from "react-router-dom";

import { useForm } from "react-hook-form";

import { useFirebase } from 'react-redux-firebase'

const Login = () => {
  const {register, handleSubmit} = useForm();
  const [hasAuthError, setHasAuthError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const firebase = useFirebase();

  const login = async ({email, password}) => {
    try {
      await firebase.auth().signInWithEmailAndPassword(email, password);
      setIsSuccess(true);
    } catch (error) {
      setHasAuthError(true);
    }
  }

  const LoginPage = () => (
    <div className="container">
      <a href="https://narratedbypoise.com" className="logo">Poise</a>
      <a href="https://narratedbypoise.com" className="back back-home">
        <i className="fas fa-long-arrow-alt-left"></i>
        &nbsp;
        Back home
      </a>
      <div className="row  justify-content-center text-center mt-5">
        <div className="col-md-12 col-lg-9 col-xl-8 mt-5">
          <div className="card screen login">
            <div className="row no-gutters">
              <div className="col-md-5">
                <div className="banner" />
              </div>
              <div className="col-md-7">
                <div className="credentials">
                  <h1 className="h3">Welcome back</h1>
                  <p>
                    Don't have an account? <Link to="/signup">Sign up</Link>
                  </p>
                  <form className="text-left" onSubmit={handleSubmit(login)}>
                    <div className="form-group">
                      <label>Email*</label>
                      <input type="text" name="email" className="form-control" ref={register}/>
                    </div>
                    <div className="form-group mb-4">
                      <label>Password*</label>
                      <input type="password" name="password" className="form-control" ref={register}/>
                    </div>
                    { hasAuthError && (
                      <p className="alert alert-warning text-center">
                        Incorrect email or password
                      </p>
                    )}
                    <div className="form-group pb-3">
                      <input type="submit" className="btn btn-primary btn-block" value="Continue" />
                    </div>
                  </form>
                  <p className="text-center mb-0">
                    <Link to="/forgot-password">Forgot password?</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return isSuccess ? <Redirect to="/" /> : <LoginPage />
}

export default Login;
